import { render, staticRenderFns } from "./AdminPickupzones.vue?vue&type=template&id=db37b30e&"
import script from "./AdminPickupzones.vue?vue&type=script&lang=js&"
export * from "./AdminPickupzones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports